import { render, staticRenderFns } from "./FlaggedUsers.vue?vue&type=template&id=452e48ee&"
import script from "./FlaggedUsers.vue?vue&type=script&lang=js&"
export * from "./FlaggedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports